import React from "react";

import "../Styles/Card.css";

import { Link } from "react-router-dom";

export default function Card(props) {
    function getTextColor(backgroundColor) {
        var r = parseInt(backgroundColor.substr(0,2),16);
        var g = parseInt(backgroundColor.substr(2,2),16);
        var b = parseInt(backgroundColor.substr(4,2),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 128) ? 'black' : 'white';
    }
    return (
        <Link className="Card" to={"/recipes/"+props.recette.ID}>
            {props.recette.logo ? <img src={"https://anatole-sot.xyz/api/recettes-gibli/uploads/categories/"+props.recette.logo+".PNG"} alt={props.recette.Name} /> : null}
            <h2>{props.recette.Title}</h2>
            <div className="tags">
                {
                    props.recette.Tags.map((tag, index) => {
                        return (
                            <span className="tag" key={index} style={{backgroundColor:"#"+tag.Color, color : getTextColor(tag.Color)}}>{tag.Name}</span>
                        );
                    })
                }
            </div>
            <div className="infos">
                <div className="personnes">
                    {props.recette.personnes} <span className="emoji"> 👥 </span>
                </div>
                <div className="temps">
                    {props.recette.Temps} <span className="emoji"> ⏱️ </span>
                </div>
            </div>
        </Link>
    );
}
